import { createContext } from "preact";
import { useContext, useState } from "preact/hooks";
import type { ComponentChildren } from "preact";

interface UserInteractionContextType {
  hasUserInteracted: boolean;
  setHasUserInteracted: (interacted: boolean) => void;
}

const UserInteractionContext = createContext<UserInteractionContextType | undefined>(undefined);

interface UserInteractionProviderProps {
  children: ComponentChildren;
}

export function UserInteractionProvider({ children }: UserInteractionProviderProps) {
  const [hasUserInteracted, setHasUserInteracted] = useState<boolean>(false);

  return (
    <UserInteractionContext.Provider value={{ hasUserInteracted, setHasUserInteracted }}>
      {children}
    </UserInteractionContext.Provider>
  );
}

export function useUserInteraction(): UserInteractionContextType {
  const context = useContext(UserInteractionContext);
  if (!context) {
    throw new Error("useUserInteraction must be used within a UserInteractionProvider");
  }
  return context;
}

